import { v4 as uuid } from 'uuid'

export const ids = {
  enterpriseName: uuid(),
  enterpriseCuit: uuid(),
  enterpriseActivity: uuid(),
  country: uuid(),
  province: uuid(),
  city: uuid(),
  street: uuid(),
  number: uuid(),
  floor: uuid(),
  apartment: uuid(),
  zipCode: uuid(),
  url: uuid(),
  corporateName: uuid(),
  corporateLastName: uuid(),
  corporateJobTitle: uuid(),
  corporateEmail: uuid(),
  corporatePhone: uuid(),
  corporateTravelAgency: uuid(),
  flightOrigin: uuid(),
  flightDestination: uuid(),
  anualSpending: uuid()
}
